import { render, staticRenderFns } from "./UsersNotif.vue?vue&type=template&id=c4b2fd4c&"
import script from "./UsersNotif.vue?vue&type=script&lang=js&"
export * from "./UsersNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports